import { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { aiBackgroundColor, themeGet, themeGetColor } from 'modules/v2/foundation/theme';
const primaryStyles = css `
  color: ${themeGet('colors.primary.0')};
  background-color: ${themeGet('colors.primary.1000')};
  border-color: ${themeGet('colors.primary.1000')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.primary.0')};
  }

  &:disabled {
    background-color: ${themeGet('colors.primary.1000')};
    color: ${themeGet('colors.primary.0')};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      border-color: ${themeGet('colors.primary.800')};
      background-color: ${themeGet('colors.primary.800')};
    }

    &:active {
      border-color: ${themeGet('colors.primary.700')};
      background-color: ${themeGet('colors.primary.700')};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
    }
  }
`;
const secondaryStyles = css `
  color: ${themeGet('colors.text.200')};
  background-color: ${themeGet('colors.gray.0')};
  border-color: ${themeGet('colors.border.100')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.600')};
  }

  &:disabled {
    color: ${themeGet('colors.text.200')};
    background-color: ${themeGet('colors.gray.0')};
    border-color: ${themeGet('colors.gray.100')};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${themeGet('colors.gray.50')};
      border-color: ${themeGet('colors.border.100')};
    }

    &:active {
      background-color: ${themeGet('colors.gray.100')};
      border-color: ${themeGet('colors.border.100')};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
    }
  }
`;
const ghostStyles = css `
  color: ${themeGet('colors.text.200')};
  background-color: transparent;
  border-color: transparent;

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.600')};
  }

  &:disabled {
    opacity: 0.5;
    color: ${themeGet('colors.text.200')};
    background-color: transparent;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${themeGet('colors.gray.50')};
      border-color: ${themeGet('colors.border.100')};
    }

    &:active {
      background-color: ${themeGet('colors.gray.200')};
      border-color: ${themeGet('colors.border.100')};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
    }
  }
`;
const glassStyles = css `
  color: ${themeGet('colors.text.light')};
  background-color: ${themeGetColor('gray.0', 0.05)};
  border-color: ${themeGetColor('gray.0', 0.05)};

  [data-icon='falcon'] {
    color: ${themeGetColor('text.light')};
  }

  &:disabled {
    opacity: 0.5;
    color: ${themeGetColor('text.light')};
    background-color: transparent;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${themeGetColor('gray.0', 0.1)};
      border-color: ${themeGetColor('gray.0', 0.1)};
    }

    &:active {
      background-color: ${themeGetColor('gray.0', 0.2)};
      border-color: ${themeGetColor('gray.0', 0.2)};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGetColor('focus.primary')};
    }
  }
`;
const dangerStyles = css `
  color: ${themeGet('colors.gray.0')};
  background-color: ${themeGet('colors.red.500')};
  border-color: ${themeGet('colors.red.500')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.0')};
  }

  &:disabled {
    background-color: ${themeGet('colors.red.500')};
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${themeGet('colors.red.400')};
    }

    &:active {
      background-color: ${themeGet('colors.red.600')};
    }

    &:focus-visible {
      background-color: ${themeGet('colors.red.500')};
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.danger')};
    }
  }
`;
const assistantStyles = css `
  color: ${themeGet('colors.assistant.500')};
  background-color: ${themeGet('colors.assistant.50')};
  border-color: ${themeGet('colors.assistant.100')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.assistant.500')};
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${themeGet('colors.assistant.100')};
    }

    &:active {
      background-color: ${themeGet('colors.assistant.200')};
    }

    &:focus-visible {
      background-color: ${themeGet('colors.assistant.50')};
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.assistant')};
    }
  }
`;
const aiStyles = css `
  ${aiBackgroundColor('500')};
  border-color: transparent;

  &,
  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.0')};
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      ${aiBackgroundColor('400')};
    }

    &:active {
      ${aiBackgroundColor('700')};
    }

    &:focus-visible {
      ${aiBackgroundColor('500')};
      box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.info')};
    }
  }
`;
export function getButtonAppearance(appearance) {
    switch (appearance) {
        case 'secondary':
            return secondaryStyles;
        case 'ghost':
            return ghostStyles;
        case 'glass':
            return glassStyles;
        case 'danger':
            return dangerStyles;
        case 'assistant':
            return assistantStyles;
        case 'ai':
            return aiStyles;
        case 'primary':
        default:
            return primaryStyles;
    }
}
